import { render } from "./CardTarif.vue?vue&type=template&id=61ff5cfc&scoped=true"
import script from "./CardTarif.vue?vue&type=script&lang=js"
export * from "./CardTarif.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-61ff5cfc"

export default script